import { createFileRoute } from '@tanstack/react-router';

import { BillingPanel } from '../../../features/billing/BillingPanel';

/** Spec 12.1's player billing screen. The same panel the studio uses (spec 11.3). */
export const Route = createFileRoute('/$lang/app/billing')({ component: Page });

function Page(): React.ReactNode {
  return <BillingPanel lead="solo" />;
}
